<template>
  <div class="page">
    <div class="form">
      <div class="Audit-opinion">
        <p class="title">办理情况</p>
        <van-field
            class="textarea"
            v-model="content"
            autosize
            type="textarea"
            maxlength="500"
            placeholder="请输入"
          />
        <div class="tip">{{ content.length }}/500</div>
      </div>
    </div>
    <div class="upload-box">
      <upload @fileuploadData="fileUploadData" :fileBizType="110" :sourceId="basicId"></upload>
    </div>
    <div class="btn-box">
      <div class="btn" :class="{'disable': !content}" @click="confirm">提交</div>
    </div>
  </div>
</template>

<script>
    import upload from '../components/upload';
    import api from '../../../../service/modules/refund';

    export default {
        components: { upload },
        data () {
            return {
                content: '',
                basicId: '',
                Imglist: [],
                data: {}, // 退货单的detail字段
                fileUrl: []

            };
        },
        created () {
            this.data = this.$route.query.data;
        },
        methods: {
            fileUploadData (val, fileUrl) {
                this.Imglist = val;
                this.fileUrl = fileUrl
            },
            confirm () {
                try {
                    if (!this.content.trim()) {
                        this.content = '';
                        return this.$Toast({
                            message: '请输入办理情况'
                        });
                    }
                    let img = this.Imglist.join(',');
                    console.log(img, 'img')
                    const param = {
                        attachId: img,
                        flowId: this.data.flowId,
                        content: this.content,
                        attachUrl: this.fileUrl.join(',')

                    };
                    api.complainFeedback(param).then(res => {
                        if (res.ret === 0) {
                            this.$Toast({
                                message: '提交成功',
                                icon: 'passed'
                            });
                            setTimeout(() => {
                                this.$router.back()
                            }, 1500)
                        }
                    });
                } catch (err) {
                    alert(err)
                }
            }
        }
    };
</script>
<style lang="less" scoped>
.page {
  .form {
    padding: 0 16px;
    .cell-list {
      margin-bottom: 24px;
      .cell {
        padding: 20px 0;
        border-bottom: 1px solid #eeeeee;
        display: flex;
        justify-content: space-between;
        align-items: center;
        .label {
          font-size: 14px;
          color: #666666;
          span {
            color: red;
            vertical-align: middle;
            margin-left: 2px;
          }
        }
        /deep/.content {
          .van-field__control {
            text-align: right;
          }
          // .van-radio__label {
          //   font-size: 14px;
          //   color: #171a1d;
          // }
          // .van-radio__icon {
          //   display: flex;
          //   align-items: center;
          // }
          span {
            font-size: 14px;
            color: #171a1d;
          }
          .arrow {
            font-size: 16px;
            vertical-align: sub;
            margin-left: 5px;
          }
        }
      }
    }
    .Audit-opinion {
      position: relative;
      .title {
        font-size: 14px;
        color: #666666;
        margin-bottom: 12px;
        margin-top: 20px;
        &::after {
          content: "*";
          margin-left: 5px;

          font-family: PingFangSC-Regular;
          font-weight: 400;
          font-size: 14px;
          color: #F94F4E;
        }
      }
      /deep/.textarea {
        width: 100%;
        background: #f8f9fb;
        padding: 16px 4px 16px 16px;
        border-radius: 4px 4px 0 0;
        border: 0;
        font-size: 14px;
        line-height: 20px;
        box-sizing: border-box;
        .van-field__control {
          min-height: 120px;
          max-height: 320px;
        }
         .van-field__control::-webkit-scrollbar {
              width: 3px;
          }
          .van-field__control::-webkit-scrollbar-thumb {
              background: #E4E5E8;
          }
          .van-field__control::-webkit-scrollbar-track {
              background: #F8F9FB;
          }
      }
      .tip {
        text-align: right;
        padding-right: 16px;
        background: #f8f9fb;
        width: 100%;
        position: relative;
        top: -15px;
        font-size: 14px;
        color: #cccccc;
        border-radius: 0 0 4px 4px;
        line-height: 25px;
      }
    }
  }
  .upload-box {
    padding: 0 16px;
    .title {
      font-size: 14px;
      color: #171a1d;
      line-height: 14px;
      margin-bottom: 12px;
    }
    /deep/.van-uploader {
      width: 80px;
      height: 80px;
      top: 0 !important;
      width: 100%;
      .van-uploader__input-wrapper {
        border: 1px dashed #a2a3a4;
        height: 75px;
        width: 75px;
        align-items: center;
        justify-content: space-around;
        .camera-icon {
          width: 22px;
          height: 22px;
          position: absolute;
          top: 50%;
          left: 50%;
          transform: translate(-50%, -50%);
        }
      }
      .van-icon-clear::before {
        content: "";
        width: 18px;
        height: 18px;
        background-image: url("../../../../assets/refund/ic_delete.png");
      }
    }
  }
  .btn-box {
    padding: 0 16px;
    position: fixed;
    width: 100%;
    bottom: 20px;
    .btn {
      background-color: #37b375;
      padding: 16px 0;
      text-align: center;
      font-size: 16px;
      color: #ffffff;
      border-radius: 4px;
    }
    .disable {
      opacity: 0.5;
    }
  }
}
</style>
